export const INTERNAL_ERROR = '500 Internal Server Error'

export const GLOBAL_ERROR = 'Something went wrong'
